var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablerBrandSketch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26196 10.878L11.262 19.667C11.662 20.107 12.353 20.107 12.753 19.667L20.753 10.877C21.066 10.533 21.102 10.018 20.84 9.63403L17.303 4.44003C17.2114 4.30604 17.0887 4.19633 16.9453 4.12037C16.8019 4.04441 16.6422 4.00448 16.48 4.00403H7.55395C7.39169 4.00448 7.23198 4.04441 7.0886 4.12037C6.94521 4.19633 6.82247 4.30604 6.73095 4.44003L3.19095 9.63203C2.92795 10.017 2.96396 10.533 3.27796 10.878H3.26196Z",
    stroke: "#FC5D1B",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerBrandSketch);
export default __webpack_public_path__ + "static/media/tabler_brand-sketch.9b19e2cc734af91ac06accc8d1b1192f.svg";
export { ForwardRef as ReactComponent };